import { RuleAction } from "./RuleAction";
import { RelevantAttributes } from "./extractRelevantAttributes";

export enum ActionReportType {
  DIRECT_DOMAIN_MAP = "DOMAIN_MAP",
  COOKIE_MANAGEMENT_PLATFORM = "COOKIE_MANAGEMENT_PLATFORM",
}

export interface ActionsReport {
  processingTime: number;
  url: string;
  actions: Array<ActionReportItem>;
  type: ActionReportType;
  errors: Array<string>;
}

export interface ActionReportItem {
  processingTime: number;
  elementsFound: number;
  elementClicked?: RelevantAttributes;
  action?: RuleAction;
  selector?: string;
  tagName?: string;
  clicked: boolean;
  errors: Array<string>;
}

/**
 *
 * @param clickReport sends back a click report object as summary of action(s) performed
 */
export const sendActionsReport = (actionsReport: ActionsReport) => {
  chrome.runtime.sendMessage({
    action: "sendReport",
    data: actionsReport,
    url: window.location.href,
  });
};
